import React from 'react';
import { CoreValuesWorksheet } from './CoreValuesWorksheet';
import { CourseWorksheet } from './CourseWorksheet';

export const CourseWorksheetRenderer = props => {
  const mapping = {
    'core-values': CoreValuesWorksheet,
  };

  const Component = mapping[props.item.fields.slug] || CourseWorksheet;

  return <Component {...props} />;
};
